<template>
	<v-card tile elevation="0" style="height: 100%; overflow-y: hidden">
		<v-card-title class="text-left card-header fixed-card-title2">
			<v-row no-gutters>
				<v-col cols="6">
					<v-toolbar-title>{{ $t('add-release-note') }}</v-toolbar-title>
				</v-col>
				<v-spacer />
				<v-icon color="white" @click="closeDrawer">mdi-close</v-icon>
			</v-row>
		</v-card-title>
		<v-card-text class="pa-4 pb-0 overflow-y-auto" style="height: calc(100vh - 130px)">
			<v-row dense>
				<v-col cols="12">
					<v-select
						v-model="typeOfDocument"
						:label="$t('document-type')"
						:items="documentTypes"
						item-text="title"
						outlined
						hide-details
						:menu-props="{ maxHeight: 200, offsetY: true }" />
				</v-col>
				<v-col cols="12">
					<v-select
						v-model="organizationId"
						:label="$t('organization')"
						:items="filteredInstitutions"
						item-text="institutionName"
						item-value="id"
						outlined
						hide-details
						:menu-props="{ maxHeight: 200, offsetY: true }" />
				</v-col>
				<v-col cols="12">
					<v-file-input
						v-model="file"
						:label="$t('select-file')"
						outlined
						hide-details="auto"
						show-size
						prepend-icon=""
						:accept="extensionList.join(', ')"
						append-icon="mdi-file-upload"
						:rules="rules"
						@change="validateFileInput" />
				</v-col>
				<v-col cols="12">
					<v-textarea v-model="documentDescription" :label="$t('description')" dense outlined hide-details rows="12" />
				</v-col>
			</v-row>
		</v-card-text>
		<v-container class="px-4">
			<v-row dense>
				<v-col cols="6" order="1">
					<v-btn @click="closeDrawer()" color="secondary" style="color: black" block>
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-tooltip top v-if="!addButtonEnabled">
					<template v-slot:activator="{ on, attrs }">
						<v-col cols="6" v-bind="attrs" v-on="on" order="2">
							<v-btn disabled block>{{ $t('add') }}</v-btn>
						</v-col>
					</template>
					<span>{{ $t('fill-all-fields-warning') }}</span>
				</v-tooltip>
				<v-col cols="6" v-else order="2">
					<v-btn @click="addDocument()" color="dark_purple" style="color: white" block>
						{{ $t('add') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>
<script>
import { mapActions, mapState } from 'vuex';
export default {
	name: 'AddReleaseNote',
	data () {
		return {
			documentTypes: [
				{
					title: 'User Guide',
				},
				{
					title: 'Release Note',
				},
			],
			typeOfDocument: null,
			filteredInstitutions: [{ id: null, institutionName: this.$t('none') }],
			organizationId: null,
			file: null,
			formValid: false,
			rules: [
				(value) => !!value || this.$t('required-field'),
				(value) => !value || this.extensionList.includes(value.type) || this.$t('please-select-valid-file-type'),
				(value) => !value || value.size < 15000000 || this.$t('file-size-limit') + ' 15 MB',
			],
			documentDescription: '',
			extensionList: [
				'image/jpg',
				'image/png',
				'image/webp',
				'image/jpeg',
				'image/gif',
				'image/bmp',
				'image/svg',
				'text/plain',
				'text/csv',
				'text/html',
				'application/msword',
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				'application/x-7z-compressed',
				'application/zip',
				'application/x-zip-compressed',
				'application/vnd.rar',
				'application/x-tar',
				'application/pdf',
				'application/vnd.ms-excel',
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'application/vnd.ms-powerpoint',
				'application/vnd.openxmlformats-officedocument.presentationml.presentation',
				'application/vnd.oasis.opendocument.presentation',
				'application/vnd.oasis.opendocument.spreadsheet',
				'application/vnd.oasis.opendocument.text',
				'application/rtf',
			],
		};
	},
	computed: {
		...mapState({
			medicalInstitutions: (state) => state.medicalInstitutions.medicalInstitutions,
		}),
		addButtonEnabled () {
			return this.typeOfDocument && this.file && this.formValid && this.documentDescription.trim();
		},
	},
	async mounted () {
		if (this.medicalInstitutions === null || this.medicalInstitutions.length === 0) {
			await this.getMedicalInstitutions();
		}
		this.filteredInstitutions = [
			...this.filteredInstitutions,
			...this.medicalInstitutions.filter((inst) => inst.id !== 0),
		];
	},
	methods: {
		...mapActions({
			addReleaseNote: 'releaseNotes/addReleaseNote',
			getReleaseNotes: 'releaseNotes/getAllReleaseNotes',
			getMedicalInstitutions: 'medicalInstitutions/getMedicalInstitutions',
		}),
		async addDocument () {
			const request = new FormData();
			request.append('TypeOfDocument', this.typeOfDocument);
			this.organizationId && request.append('DedicatedToOrganizationId', this.organizationId);
			request.append('File', this.file);
			request.append('DocumentDescription', this.documentDescription);
			this.closeDrawer();
			await this.addReleaseNote(request);
			await this.getReleaseNotes();
		},
		validateFileInput (file) {
			this.formValid = file && file.size <= 15000000 && this.extensionList.includes(file.type);
		},
		closeDrawer () {
			this.typeOfDocument = null;
			this.organizationId = null;
			this.file = null;
			this.documentDescription = '';
			this.$store.commit('SET_DETAILS_DRAWER', false);
		},
	},
};
</script>
